import { t as __t } from "i18next";
import React, { useEffect, useMemo, useState } from 'react';
import { notifyListRefresh } from "../../utils/listNavigation";
import moment from 'moment';
import colors from '../../utils/colors';
import SmartTable from '../../components/common/table-component';
import DashboardHeader from '../../components/header/DashboardHeader';
import MobileMenu from '../../components/header/MobileMenu';
import DashboardEmployerSidebar from '../../components/header/DashboardSidebar';
import CopyrightFooter from '../../components/footer/employers/CopyrightFooter';
import { t } from 'i18next';
import BackPrevious from "../../components/back-previous";
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { callSearchAgentInfo, callUploadFile } from '../../api/settings/service';
import DataAutoComplete from "../../components/auto-complete";
import { approveOrRejectCommissionPayout, callApproveCommission, callGetCommissionDetails, callGetCommissionDetailsByAgentId, callGetCommissionDetailsSelect, callGetCommissionPayout, createCommissionPayout } from '../../api/contract/service';
import PermissionWrapper from '../../components/common/PermissionWrapper';
import SwalAlert from '../../components/common/alert';
import { decodeBase64, FormatCurrencys, getLaosDateTime } from '../../utils/commonUtil';
import FileUploadGrid from '../../components/upload-file';
import { set } from 'react-hook-form';
import { APPROVE, CANCEL } from '../../utils/commonType';
import { callExportCommissionPDF, callExportLifeContractPDF } from '../../api/export';
import './commission-ui-only.css';
import { findLoggedAgent, getCommissionAgentScope } from './commissionAgentScope';

const defaultForm = {
    payment_method: 'TRANSFER',
    reference_no: '',
    paid_date: moment().format('YYYY-MM-DDTHH:mm'),
    note: '',
};

const CreateCommissionPayoutPage = () => {
    const [loadingAgents, setLoadingAgents] = useState(false);
    const [loadingCommissions, setLoadingCommissions] = useState(false);
    const { pathname } = useLocation();
    const [agents, setAgents] = useState([]);
    const [selectedAgentCode, setSelectedAgentCode] = useState('');
    const menu = useSelector((state) => state.menuData);
    const userInfo = useSelector((state) => state.dataLogin);
    const agentScope = getCommissionAgentScope(userInfo);
    const isAgentUser = agentScope.isAgentUser;
    const loggedAgentId = agentScope.agentId;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [selectData, setSelectData] = useState(null);
    const [view, setView] = useState(false);
    const [buttonAction, setButtonAction] = useState("");
    const [agentData, setAgentData] = useState(null);
    const [lockedAgentData, setLockedAgentData] = useState(agentScope.initialAgent);
    const now = new Date();
    const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0, 0);
    const [resetSelectedKey, setResetSelectedKey] = useState(0);
    const [loading, setLoading] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [request, setRequest] = useState({ payoutNo: "", payoutId: null, page: 1, maxResult: 10, keyword: '', paymentMethod: 'TRANSFER', agentId: isAgentUser ? loggedAgentId : "", id: [] });

    const [agent, setAgent] = useState([]);
    const [commissionData, setCommissionData] = useState({
        result: [],
        totalRecords: 0,
        totalPages: 1,
        sumRecords: 0,
    });
    const columns = [
        {
            label: 'agentFullName',
            key: 'agentFullName',
            style: { minWidth: 180 },
        },
        {
            label: 'agentCode',
            key: 'agentCode',
            style: { minWidth: 100 },
        },
        {
            label: 'custFullName',
            key: 'custFullName',
            style: { minWidth: 180 },
        },
        {
            label: 'contractNumber',
            key: 'contractNumber',
            style: { minWidth: 120 },
        },
        {
            label: 'billNumber',
            key: 'billNumber',
            style: { minWidth: 180 },
        },
        {
            label: 'commissionAmount',
            key: 'commissionAmount',
            className: 'text-end',
            style: { minWidth: 120 },
            render: (value) => (<span style={{ color: colors.primary, fontWeight: 700 }}>
                {Number(value || 0).toLocaleString()}
            </span>),
        },
        {
            label: 'companyReceiveTotal',
            key: 'companyReceiveTotal',
            className: 'text-end',
            style: { minWidth: 120 },
            render: (value) => (
                <span style={{ color: colors.primary, fontWeight: 700 }}>
                    {Number(value || 0).toLocaleString()}
                </span>
            ),
        },
        {
            label: 'earnedDate',
            key: 'earnedDate',
            style: { minWidth: 150 },
            render: (value) => value ? moment(value).format('DD/MM/YYYY HH:mm') : '-',
        },
        {
            label: 'status',
            key: 'status',
            style: { minWidth: 120 },
            render: (value) => {
                if (Number(value) === 0) {
                    return <span className="badge bg-warning text-dark">{t("status.eearned")}</span>;
                }
                if (Number(value) === 1) {
                    return <span className="badge bg-info">{t("status.approved")}</span>;
                }
                if (Number(value) === 2) {
                    return <span className="badge bg-secondary">{t("status.inPayout")}</span>;
                }
                if (Number(value) === 3) {
                    return <span className="badge bg-success">{t("status.paid")}</span>;
                }
                if (Number(value) === 4) {
                    return <span className="badge bg-danger">{t("status.cancelled")}</span>;
                }
                return <span className="badge bg-light text-dark">{value}</span>;
            },
        },
    ];
    let params = useParams();
    useEffect(() => {
        if (Object.keys(params).length > 0 && params.id) {
            let item = decodeBase64(params.id)
            const data = JSON.parse(item)

            if (
                isAgentUser
                && loggedAgentId
                && data?.agentId
                && String(data.agentId) !== String(loggedAgentId)
            ) {
                SwalAlert.error(__t("uiText.text023"), __t("uiText.text024"));
                navigate(-1);
                return;
            }

            if (data.view) {
                setView(data.view)
            }

            const effectiveAgentId = isAgentUser ? loggedAgentId : data.agentId;
            setRequest((pre) => ({
                ...pre,
                payoutId: data.id,
                agentId: effectiveAgentId,
                payoutNo: data.payoutNo,
                paymentMethod: data.paymentMethod,
                note: data.note,
                totalItems: data.totalItems,
                commissionAmount: data.totalCommission,
                companyReceiveTotal: data.companyReceiveTotal
            }))
            setAgentData({
                agentId: effectiveAgentId,
                agentCode: effectiveAgentId,
                firstName: data.agentFullName || '',
                lastName: '',
            })
        }
    }, [params.id, isAgentUser, loggedAgentId]);

    useEffect(() => {
        const initializeLockedAgent = async () => {
            if (!isAgentUser) {
                setLockedAgentData(null);
                return;
            }

            if (!loggedAgentId) {
                setData({ result: [], totalRecords: 0, totalPages: 1, sumRecords: 0 });
                return;
            }

            const lockedAgent = await findLoggedAgent({
                dispatch,
                callSearchAgentInfo,
                scope: agentScope,
            });

            const normalizedAgent = lockedAgent || agentScope.initialAgent;
            if (normalizedAgent) {
                setLockedAgentData(normalizedAgent);
                setAgent([normalizedAgent]);
                setRequest((prev) => ({
                    ...prev,
                    agentId: loggedAgentId,
                    agentData: normalizedAgent,
                }));
            } else {
                setRequest((prev) => ({
                    ...prev,
                    agentId: loggedAgentId,
                }));
            }

            if (!params.id) {
                await loadDataCom({ page: 1, agentId: loggedAgentId, payout: 1 });
            }
        };

        initializeLockedAgent();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAgentUser, loggedAgentId, agentScope.agentCode, params.id]);
    const [data, setData] = useState({
        result: [],
        totalRecords: 0,
        totalPages: 1,
        sumRecords: 0,
    });
    const loadDataCom = async (e) => {
        if (isAgentUser && !loggedAgentId) return;

        let d = {
            ...request,
            payout: view ? 2 : agentData ? 3 : 1,
            ...(isAgentUser ? { agentId: loggedAgentId } : {}),
        };
        if (e) {
            d = {
                ...d,
                ...e,
                ...(isAgentUser ? { agentId: loggedAgentId } : {}),
            }
        }
        console.log(d)
        const rsp = await dispatch(callGetCommissionDetails(d));
        if (rsp?.payload?.responseCode === "00000") {
            setData(rsp.payload.data)

        }

    }
    const loadDataComSelect = async (id) => {
        const rsp = await dispatch(callGetCommissionDetailsSelect({ payoutId: id }));
        if (rsp?.payload?.responseCode === "00000") {
            setSelectData(rsp.payload.data)
        }

    }
    const downloadPDF = async (e) => {
        e.preventDefault()
        try {
            let body = { payoutNo: request.payoutNo, insuranceType: data.result[0].insuranceType, agentName: agent[0].firstName + " " + agent[0].lastName, agentCode: agent[0].agentCode, billDate: getLaosDateTime(), payoutId: request.payoutId };
            let response = await callExportCommissionPDF(body);
            console.log(agent)
            if (response === null) {
                SwalAlert.error(__t("uiText.text023"), __t("uiText.text025"));
                return
            }
            const url = URL.createObjectURL(response);
            const link = document.createElement("a");
            link.href = url;
            link.download = `commission_${moment().format("YYYYMMDDHHmmss")}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            SwalAlert.error(__t("uiText.text023"), __t("uiText.text025"));
        }
    };
    const handleOpenConfirm = (e) => {
        e.preventDefault()
        console.log(request?.file?.file[0])
        if (!request?.file?.file[0] && buttonAction === "approve") {
            SwalAlert.error(__t("uiText.text023"), __t("uiText.text179"));
            return;
        }
        SwalAlert.confirmInput(agentData ? view ? t("swal.title." + buttonAction) : t("swal.title.editPayout") : t("swal.title.createPayout"), t("swal.text.confirmCreatePayout"), buttonAction === "reject", async (e) => {
            try {
                if (!view) {
                    let req = {
                        payoutId: request.payoutId,
                        id: request.id,
                        totalItems: request.id.length,
                        totalCommission: request.summary.commissionAmount,
                        companyReceiveTotal: request.summary.companyReceiveTotal,
                        paymentMethod: request.paymentMethod,
                        note: request.note,
                        agentId: isAgentUser ? loggedAgentId : request.agentId
                    }
                    const rsp = await dispatch(createCommissionPayout(req));
                    if (rsp?.payload?.responseCode === "00000") {
                        if (window.history.length > 1) {
                            notifyListRefresh();
                            navigate(-1);
                        }
                    } else {
                        SwalAlert.error(__t("uiText.text023"), rsp?.payload?.responseCode + " - " + rsp?.payload?.responseDescription);
                    }
                } else {
                    let imagePath = null;
                    if (buttonAction === "approve") {
                        if (request.file !== null) {
                            const upload = await dispatch(callUploadFile(request.file.file));
                            if (upload?.payload?.responseCode === "00000") {
                                imagePath = JSON.stringify(upload?.payload?.data)
                            }
                        }
                    }
                    let req = {
                        status: buttonAction === "approve" ? 2 : buttonAction === "reject" ? 3 : 0,
                        reversedReason: buttonAction === "reject" ? e : null,
                        slipPath: imagePath,
                        payoutId: request.payoutId
                    }
                    const rsp = await dispatch(approveOrRejectCommissionPayout(req));
                    if (rsp?.payload?.responseCode === "00000") {
                        if (window.history.length > 1) {
                            notifyListRefresh();
                            navigate(-1);
                        }
                    } else {
                        SwalAlert.error(__t("uiText.text023"), rsp?.payload?.responseCode + " - " + rsp?.payload?.responseDescription);
                    }
                }
            } catch (error) {
                SwalAlert.error(__t("uiText.text023"), __t("uiText.text024"),);
            }
        })
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setRequest((prev) => ({ ...prev, [name]: value }));
    };
    const loadData = async (value) => {
        if (isAgentUser) {
            if (!loggedAgentId) return;
            const lockedAgent = await findLoggedAgent({
                dispatch,
                callSearchAgentInfo,
                scope: agentScope,
            });
            if (lockedAgent) {
                setLockedAgentData(lockedAgent);
                setAgent([lockedAgent]);
            }
            return;
        }

        if (value?.id) {
            let data = { keyword: null, page: 1, maxResult: 1, agentId: value?.id };
            const rsp = await dispatch(callSearchAgentInfo(data));
            if (rsp?.payload?.responseCode === "00000" && rsp?.payload?.data?.result.length >= 1) {
                setAgent(rsp.payload.data.result)
            }

        } else {
            let data = { keyword: value, page: 1, maxResult: 10, agentId: null };
            const rsp = await dispatch(callSearchAgentInfo(data));
            if (rsp?.payload?.responseCode === "00000" && rsp?.payload?.data?.result.length >= 1) {
                setAgent(rsp.payload.data.result)
            }
        }

    };

    const onSelect = async (item) => {
        if (isAgentUser) {
            const lockedAgent = lockedAgentData || agentScope.initialAgent;
            setRequest((prev) => ({
                ...prev,
                agentId: loggedAgentId,
                agentData: lockedAgent || prev.agentData,
            }));

            if (loggedAgentId) {
                if (agentData) {
                    loadDataComSelect(request?.payoutId)
                }
                loadDataCom({ agentId: loggedAgentId })
            }
            return;
        }

        if (item) {
            setRequest((prev) => ({
                ...prev,
                agentId: item.agentId,
                agentData: item,
            }));
            if (item?.agentId) {
                if (agentData) {
                    loadDataComSelect(request?.payoutId)
                }
                loadDataCom({ agentId: (item?.agentId ? item.agentId : null) })
            }
        } else {
            setResetSelectedKey((prev) => prev + 1);
            setRequest((prev) => ({
                ...prev,
                agentId: null,
                agentData: null,
                id: [],
                summary: {}
            }));
            setData({
                result: [],
                totalRecords: 0,
                totalPages: 1,
                sumRecords: 0
            })
        }

    }
    const handleImageSelect = (e) => {
        setRequest((prev) => ({
            ...prev,
            file: { file: e }
        }));
    };
    return (
        <div className="page-wrapper dashboard commission-ui-only">
            <span className="header-span"></span>
            <DashboardHeader />
            <MobileMenu />
            <DashboardEmployerSidebar />
            <form onSubmit={handleOpenConfirm}>
                <section className="user-dashboard">
                    <div className="dashboard-outer">
                        <div className="upper-title-box back-title-group commission-page-title">
                            <BackPrevious />
                            <h4>{agentData ? view ? t("contracts.view") : t("contracts.edit") : t("contracts.add")}</h4>
                        </div>
                        <div className="ls-widget commission-card">
                            <div className="tabs-box">
                                <div className="widget-content p-4">
                                    <div className="card shadow-sm border-0 mb-3 h-100 commission-inner-card">
                                        <div className="default-form card-body commission-form">
                                            <div className="row">
                                                <div className="col-md-4 form-group">
                                                    <label> {t('commission.agentCode')}<span className="text-danger">*</span></label>
                                                    <DataAutoComplete
                                                        disabled={isAgentUser || agentData || view}
                                                        label="firstName"
                                                        id="agentCode"
                                                        initialData={isAgentUser ? (lockedAgentData || agentScope.initialAgent) : agentData}
                                                        data={agent}
                                                        autoSelect={true}
                                                        placeholder={t('contract.keyword')}
                                                        handleChange={loadData}
                                                        onSelect={onSelect}
                                                    />
                                                </div>

                                                <div className="col-md-4 form-group">
                                                    <label> {t('commission.paymentMethod')} <span className="text-danger">*</span> </label>
                                                    <select className="chosen-single form-select"
                                                        name="paymentMethod"
                                                        disabled={view}
                                                        onChange={(e) => handleChange(e, null)}
                                                        value={request.paymentMethod}
                                                        required
                                                    >
                                                        <option value="TRANSFER">{t('commission.transfer')}</option>
                                                        <option value="CASH">{t('commission.cash')}</option>
                                                    </select>
                                                </div>
                                                <div className="col-md-4 form-group">
                                                    <label> {t('commission.note')}<span className="text-danger">*</span></label>
                                                    <input
                                                        disabled={view}
                                                        type="text"
                                                        name="note"
                                                        className="form-control-uld"
                                                        placeholder={t('commission.note')}
                                                        onChange={(e) => handleChange(e, null)}
                                                        value={request.note}
                                                        autoComplete="off"
                                                        required />
                                                </div>
                                                {view && <div className="col-12 col-md-12 form-group">
                                                    <label> {t('commission.imagePath')} <span className="text-danger">*</span> </label>
                                                    <FileUploadGrid
                                                        folderName="commission-payout"
                                                        onChange={(e) => handleImageSelect(e)}
                                                        accept="image/*,application/pdf"
                                                        required={buttonAction === "reject" ? false : true}
                                                    />
                                                </div>}
                                                {/* <div className="col-md-5">
                                                    <label className="form-label fw-bold">Paid Date</label>
                                                    <input
                                                        type="datetime-local"
                                                        className="form-control"
                                                        value={form.paid_date}
                                                        onChange={(e) =>
                                                            setForm((prev) => ({ ...prev, paid_date: e.target.value }))
                                                        }
                                                    />
                                                </div> */}

                                                {/* <div className="col-md-6">
                                                    <label className="form-label fw-bold">Reference No</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={form.reference_no}
                                                        onChange={(e) =>
                                                            setForm((prev) => ({ ...prev, reference_no: e.target.value }))
                                                        }
                                                        placeholder="BCEL / STB / transaction no"
                                                    />
                                                </div> */}

                                            </div>
                                        </div>
                                    </div>

                                    <div className="row g-3 mb-3">
                                        <div className="col-md-3">
                                            <div className="card border-0 shadow-sm h-100 commission-stat-card">
                                                <div className="card-body">
                                                    <div className="text-muted mb-1">{t('commission.agent')}</div>
                                                    <div className="fw-bold">
                                                        {request.agentData
                                                            ? `${request.agentData.agentCode} - ${request.agentData.firstName || ''} ${request.agentData.lastName || ''}`.trim()
                                                            : (lockedAgentData
                                                                ? `${lockedAgentData.agentCode} - ${lockedAgentData.firstName || ''} ${lockedAgentData.lastName || ''}`.trim()
                                                                : '-')}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="card border-0 shadow-sm h-100 commission-stat-card">
                                                <div className="card-body">
                                                    <div className="text-muted mb-1">{t('commission.countContract')}</div>
                                                    <div className="fw-bold">{request?.id?.length || request?.totalItems || 0}</div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-3">
                                            <div className="card border-0 shadow-sm h-100 commission-stat-card">
                                                <div className="card-body">
                                                    <div className="text-muted mb-1">{t('commission.commission')}</div>
                                                    <div className="fw-bold">{FormatCurrencys(request?.summary?.commissionAmount || request?.commissionAmount || 0)}</div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-3">
                                            <div className="card border-0 shadow-sm h-100 commission-stat-card">
                                                <div className="card-body">
                                                    <div className="text-muted mb-1">{t('commission.companyReceiveTotal')}</div>
                                                    <div className="fw-bold">{FormatCurrencys(request?.summary?.companyReceiveTotal || request?.companyReceiveTotal || 0)}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="card shadow-sm border-0 mb-3 h-100 commission-inner-card">
                                        <div className="card-body">
                                            <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
                                                <div>
                                                    <h5 className="mb-1">{t('commission.commissionList')}</h5>
                                                    <div className="text-muted">
                                                        {t('commission.commissionListDescription')}
                                                    </div>
                                                </div>

                                                {!view && <div className="d-flex align-items-center gap-2">
                                                    <button
                                                        type="submit"
                                                        className="btn btn-primary"
                                                        disabled={request.id.length === 0 || submitting}
                                                    >
                                                        {agentData ? t('commission.editPayout') : t('commission.createPayout')}
                                                    </button>
                                                </div>}
                                                {view && <div className="d-flex align-items-center gap-2">
                                                    <button
                                                        className="btn btn-success"
                                                        onClick={downloadPDF}
                                                    >
                                                        {t('commission.downloadPDF')}
                                                    </button>

                                                </div>}
                                                {view && <div className="d-flex align-items-center gap-2">
                                                    <PermissionWrapper permission={APPROVE}><button
                                                        type="submit"
                                                        className="btn btn-primary"
                                                        onClick={(e) => setButtonAction("approve")}
                                                    >
                                                        {t('commission.approvePayout')}
                                                    </button>
                                                    </PermissionWrapper>
                                                </div>}
                                                {view && <div className="d-flex align-items-center gap-2">
                                                    <PermissionWrapper permission={CANCEL}> <button
                                                        type="submit"
                                                        className="btn btn-warning"
                                                        onClick={(e) => setButtonAction("reject")}
                                                    >
                                                        {t('commission.rejectPayout')}
                                                    </button>
                                                    </PermissionWrapper>
                                                </div>
                                                }
                                            </div>


                                            <SmartTable
                                                showSumRecord={false}
                                                showConfirmButton={false}
                                                resetSelectedKey={resetSelectedKey}
                                                columns={columns}
                                                data={data}
                                                onLazyLoad={(params) => loadDataCom(params)}
                                                selectable={view ? false : true}
                                                rowKey="id"
                                                statusCheck={agentData ? ['1', '4'] : ['1', '4']}
                                                statusColKey={agentData ? 'status' : 'status'}
                                                recordsTableFilter={true}
                                                customPagination={true}
                                                externalSelectedIds={selectData}
                                                summaryColumns={['commissionAmount', 'companyReceiveTotal']}
                                                onSelectionSummaryChange={({ ids, summary }) => {
                                                    setRequest((prev) => ({ ...prev, id: ids, summary: summary }));
                                                }}
                                                onLoadSelectAll={async ({ }) => {
                                                    const agentId = isAgentUser ? loggedAgentId : request.agentId;
                                                    const statuses = agentData ? [1, 4, 2] : [1, 4];
                                                    const responses = await Promise.all(
                                                        statuses.map((status) => dispatch(callGetCommissionDetailsByAgentId({
                                                            agentId,
                                                            status,
                                                            type: request.insuranceType,
                                                        })))
                                                    );

                                                    const ids = responses.flatMap((rsp) => (
                                                        rsp?.payload?.responseCode === "00000" && Array.isArray(rsp?.payload?.data)
                                                            ? rsp.payload.data
                                                            : []
                                                    ));

                                                    return { ids: Array.from(new Set(ids)) };
                                                }}
                                            />

                                        </div>
                                    </div>
                                    {/* 
                                    <CreatePayoutConfirmModal
                                        show={showConfirmModal}
                                        onClose={() => !submitting && setShowConfirmModal(false)}
                                        onConfirm={handleCreatePayout}
                                        submitting={submitting}
                                        agent={selectedAgent}
                                        form={form}
                                        summary={summary}
                                        selectedIds={selectedIds}
                                    /> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </form>
            <CopyrightFooter />
        </div>

    );
};

export default CreateCommissionPayoutPage;